var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ma-auto green lighten-2 white--text",attrs:{"disabled":_vm.invalid,"block":""},on:{"click":_vm.sendMsg}},[_c('v-icon',[_vm._v("mdi-whatsapp")]),_vm._v(" Whatsapp ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }